import { render, staticRenderFns } from "./recruitCompanyProperty.vue?vue&type=template&id=24e6fc6e"
import script from "./recruitCompanyProperty.vue?vue&type=script&lang=js"
export * from "./recruitCompanyProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports